import REQUIRED_FIELDS from '@/pages/events/REQUIRED_FIELDS';
import usePagedQuery from '@/hooks/usePagedQuery';
import { STUDENT_IMPACT_MESSAGE, sumActualStudents } from '@/utils/studentImpact';

export default function useEventStudentImpact(network, schoolStart, schoolEnd) {
  const events = usePagedQuery('events', {
    where: {
      eager: {
        $where: {
          $and: REQUIRED_FIELDS.$and,
          networkId: network?.id,
          completed: true,
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          }
        }
      }
    }
  }, { source: 'dashboard-year/useEventStudentImpact', message: STUDENT_IMPACT_MESSAGE });

  const totalCount = sumActualStudents(events.data);

  return [
    events,
    totalCount
  ];
}
